<template>
  <div v-if="isShowView" class="option-edit-group">
    <div class="text">
      <p class="left">已添加到自选</p>
      <p @click="editGroup" class="right">编辑分组</p>
  </div>
  </div>
</template>

<script>

export default {
  data: () => ({
    isShowView: false,
    timer: null,
    fundCode: '',
    fundName: '',
  }),

  methods: {
    showView(fundCode, fundName) {
      this.fundCode = fundCode;
      this.fundName = fundName;
      this.isShowView = true;
      this.timer = setTimeout(() => {
        this.isShowView = false;
        clearTimeout(this.timer);
      }, 3000);
    },

    hideView() {
      this.isShowView = false;
      clearTimeout(this.timer);
    },

    editGroup() {
      this.hideView();
      clearTimeout(this.timer);
      this.$groupList.showView(this.fundCode, this.fundName);
      // 获取用户信息
      // if (this.$user.uid) {

      // } else {
      //   // 跳转登录
      //   multi.$user.login();
      // }
    },
  },
};
</script>

<style scoped>

.option-edit-group {
  position: fixed;
  bottom: 300px;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  display: flex;
}

.text {
  display: flex;
  width: 686px;
  align-self: center;
  justify-self: center;
  height: 75px;
  background-color: rgba(52,55,74,0.96);
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px;
}

.left {
  font-size: 24px;
  margin-left: 28px;
  color: #ffffff;
}

.right {
  font-size: 24px;
  color: #3A90FA;
  margin-right: 28px;
}
</style>
